/**
 * Weighting for interpretive emphasis — larger weights influence synthesis more.
 */

export const WEIGHTS = {
  lifePath: 5,
  expression: 5,
  soulUrge: 4,
  personality: 3,
  birthday: 2,
  maturity: 3,
  personalYear: 4,
  personalMonth: 2,
  masterPresence: 2,
  karmicDebt: 2,
  nameRepetition: 1,
};

/**
 * Build weighted digit tallies from core numbers (masters collapsed to value for family themes).
 */
function toThemeDigit(n) {
  const v = Number(n);
  if (v === 11 || v === 22 || v === 33) {
    return v === 11 ? 2 : v === 22 ? 4 : 6;
  }
  return Math.min(9, Math.max(1, v));
}

export function weightedDigitTally(coreBundle, nameGrid) {
  const tally = {};
  const add = (digit, w, source) => {
    const d = toThemeDigit(digit);
    if (!tally[d]) tally[d] = { score: 0, sources: [] };
    tally[d].score += w;
    tally[d].sources.push(source);
  };

  const n = coreBundle.numbers;
  add(n.lifePath.value, WEIGHTS.lifePath, 'lifePath');
  add(n.expression.value, WEIGHTS.expression, 'expression');
  add(n.soulUrge.value, WEIGHTS.soulUrge, 'soulUrge');
  add(n.personality.value, WEIGHTS.personality, 'personality');
  add(n.birthday.value, WEIGHTS.birthday, 'birthday');
  add(n.maturity.value, WEIGHTS.maturity, 'maturity');
  add(n.personalYear.value, WEIGHTS.personalYear, 'personalYear');
  add(n.personalMonth.value, WEIGHTS.personalMonth, 'personalMonth');

  Object.keys(nameGrid.counts).forEach((k) => {
    const digit = Number(k);
    const c = nameGrid.counts[digit];
    if (c > 1) {
      add(digit, WEIGHTS.nameRepetition * (c - 1), `nameRepeat:${digit}`);
    }
  });

  const masters = [
    n.lifePath,
    n.expression,
    n.soulUrge,
    n.personality,
    n.birthday,
    n.maturity,
    n.personalYear,
    n.personalMonth,
  ].filter((x) => x && x.isMaster);

  return { tally, masterCount: masters.length };
}
